module.exports = __webpack_public_path__ + "static/media/ic-actions-search.2ac888f3.svg";